import React from "react";

export const NavContext = React.createContext();
export const NavDispatchContext = React.createContext();

function NavProvider({children}) {
    const [state,setstate] = React.useState(false)
    return(
        <NavContext.Provider value={state}>
            <NavDispatchContext.Provider value={setstate} >
                {children}
            </NavDispatchContext.Provider>
        </NavContext.Provider>
    )
}

export {NavProvider};
